import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/otud2dwa_Flexi.png";

export default function RepairFooter() {
  return (
    <footer
      data-testid="repair-footer"
      className="bg-[#061226] border-t border-white/10 text-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="bg-white px-2.5 py-1.5" style={{ borderRadius: "2px" }}>
            <img src={LOGO_URL} alt="Guarda Flex" className="h-8 w-auto" />
          </div>
          <div>
            <div className="font-display font-black text-sm tracking-tight leading-none">
              <span className="text-white">GUARDA</span>
              <span className="text-slate-400"> FLEX</span>
            </div>
            <div className="text-white/50 text-xs mt-1">
              © {new Date().getFullYear()} · Querétaro, QRO., México
            </div>
          </div>
        </div>

        <nav className="flex items-center gap-6 text-xs text-white/60">
          <Link
            to="/"
            data-testid="repair-footer-home"
            className="hover:text-[#00B4D8] transition-colors"
          >
            Sitio principal
          </Link>
          <Link
            to="/aviso-de-privacidad"
            data-testid="repair-footer-privacy"
            className="hover:text-[#00B4D8] transition-colors"
          >
            Aviso de privacidad
          </Link>
          <a
            href="tel:+524424319100"
            data-testid="repair-footer-phone"
            className="hover:text-[#00B4D8] transition-colors"
          >
            442 431 9100
          </a>
        </nav>
      </div>
    </footer>
  );
}
